export const dateISOFormat = (value) => {
  if (!value || value === '0001-01-01T00:00:00') return '';

  try {
    // 1. Quitamos la 'T' y reemplazamos guiones por barras para asegurar hora local
    // "2026-02-03T00:00:00" -> "2026/02/03 00:00:00"
    const safeValue = value.toString()
      .replace('T', ' ')
      .replace(/-/g, '/');

    const date = new Date(safeValue);

    // 2. Si falló la conversión (Invalid Date), devolvemos vacío
    if (Number.isNaN(date.getTime())) return '';

    // 3. Formateamos usando sv-SE para obtener YYYY-MM-DD
    return new Intl.DateTimeFormat('sv-SE').format(date);
  } catch (error) {
    return '';
  }
};

export const dateFormat = (value, locales = 'en-GB') => {
  const style = {
    dateStyle: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const dateDDMMFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit', month: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const dateDDMMYYFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit', month: '2-digit', year: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const dateDDMMYYHHMMFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const dateMMYYFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};


export const dateMMFormat = (value, locales = 'es-PE') => {
  const style = {
    month: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value)).substring(0, 3);
};

export const dateDDFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};


export const dateTimeFormat = (value, locales = 'en-GB') => {
  const style = {
    dateStyle: 'short',
    timeStyle: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const timeFormat = (value, locales = 'en-GB') => {
  const style = {
    hour: 'numeric', minute: 'numeric', second: 'numeric',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

export const dateTimeString = (date) => {
  if (typeof date === 'string') {
    return date;
  }

  return `${date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-')}T${date.toLocaleTimeString('en-GB')}`;
};
